<!-- Fora do `LayoutComponent`: a classe de versão vem da diretiva. -->
<main class="public-screen" appAccountVersionTheme>
  <div class="public-card wide">
    <div class="brand-bar"></div>
    <div class="public-card-body">
      <div class="logo">
        <img
          src="/assets/logo-smsfunnel-login.png"
          alt="SMS Funnel"
          title="SMS Funnel"
        />
      </div>
      <form class="public-form" [formGroup]="signUpFrom" (submit)="signUp()" #formCadastro="ngForm">
        <p class="screen-label">Criar conta</p>
        <p class="screen-hint">
          Preencha seus dados para abrir sua conta no SMS Funnel.
        </p>

        <p class="form-section-label">Seus dados</p>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name">Nome Completo</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="name"
                name="name"
                formControlName="name"
              />
              <small
                class="text text-danger"
                *ngIf="
                  signUpFrom.get('name').touched &&
                  signUpFrom.get('name').errors?.required
                "
                >Nome Completo é obrigatório</small
              >
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="email">Email</label>
              <input
                autocomplete="off"
                type="email"
                class="form-control"
                id="email"
                name="email"
                formControlName="email"
              />
              <small
                class="text text-danger"
                *ngIf="
                  signUpFrom.get('email').touched &&
                  signUpFrom.get('email').errors?.required
                "
                >E-mail é obrigatório</small
              >
              <small class="text text-danger" *ngIf="emailExists"
                >E-mail já cadastrado</small
              >
              <small
                class="text text-danger"
                *ngIf="signUpFrom.get('email').errors?.email"
                >E-mail inválido</small
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="phone">Telefone</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="phone"
                name="phone"
                formControlName="phone"
                appPhone
                (valueChanged)="phoneChanged($event)"
              />
              <small
                class="text text-danger"
                *ngIf="
                  signUpFrom.get('phone').touched &&
                  signUpFrom.get('phone').errors?.required
                "
                >Telefone é obrigatório</small
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="document">CPF</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="document"
                name="document"
                formControlName="document"
                appCpf
                (valueChanged)="documentChanged($event)"
              />
              <small class="text text-danger" *ngIf="documentExists"
                >CPF já cadastrado</small
              >
              <small
                class="text text-danger"
                *ngIf="
                  signUpFrom.get('document').touched &&
                  signUpFrom.get('document').errors?.required
                "
                >CPF é obrigatório</small
              >
            </div>
          </div>
        </div>

        <p class="form-section-label">Sua operação</p>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="operation">Modelo de negócio</label>
              <select class="form-control" id="operation_type" formControlName="operation_type">
                <option *ngFor="let operationType of operationTypes" [value]="operationType.value">{{ operationType.label }}</option>
              </select>
              <small *ngIf="signUpFrom.get('operation_type').errors?.required" class="text text-danger">
                Preencha com o modelo de negócio
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="invoicing">Faturamento</label>
              <select class="form-control" id="average_monthly_invoicing" formControlName="average_monthly_invoicing">
                <option value="">Selecione o faturamento</option>
                <option *ngFor="let option of invoicingOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
              <small *ngIf="signUpFrom.get('average_monthly_invoicing').errors?.required" class="text text-danger">
                Selecione o faturamento
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="checkout">Checkout</label>
              <select class="form-control" id="checkout_provider" formControlName="checkout_provider">
                <option value="">Selecione o checkout</option>
                <option *ngFor="let option of checkoutOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
              <small *ngIf="signUpFrom.get('checkout_provider').errors?.required" class="text text-danger">
                Selecione o checkout
              </small>
            </div>
          </div>
        </div>

        <p class="form-section-label">Endereço</p>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="postcode">CEP</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="postcode"
                name="postcode"
                formControlName="postcode"
                appCep
                (valueChanged)="cepChanged($event)"
              />
              <small
                class="text text-danger"
                *ngIf="
                  signUpFrom.get('postcode').touched &&
                  signUpFrom.get('postcode').errors?.required
                "
                >CEP é obrigatório</small
              >
            </div>
          </div>
        </div>

        <div class="row" *ngIf="address">
          <div class="col-md-6">
            <div class="form-group">
              <label for="street">Endereço</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="street"
                name="street"
                formControlName="street"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="number">Número</label>
              <input
                autocomplete="off"
                type="number"
                class="form-control"
                id="number"
                name="number"
                formControlName="number"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="complement">Complemento</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="complement"
                name="complement"
                formControlName="complement"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="district">Bairro</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="district"
                name="district"
                formControlName="district"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="city">Cidade</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="city"
                name="city"
                formControlName="city"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="region">Estado</label>
              <input
                autocomplete="off"
                type="text"
                class="form-control"
                id="region"
                name="region"
                formControlName="region"
              />
            </div>
          </div>
        </div>

        <div class="form-group d-grid mt-4">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="!formCadastro.valid || emailExists || documentExists"
          >
            Cadastrar
          </button>
        </div>
        <div class="public-links">
          <a [routerLink]="['/login']" ngbTooltip="Se já tem usuário, clique aqui!" placement="right">
            Entrar
            <i class="fa fa-chevron-right"></i>
          </a>
        </div>
      </form>
    </div>
  </div>
</main>
